var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0C9.25381 0 11.0833 1.79215 11.0833 4C11.0833 6.20785 9.25385 8 7 8C4.74615 8 2.91667 6.20785 2.91667 4C2.91667 1.79215 4.74615 0 7 0ZM7 1.14286C5.39 1.14286 4.08333 2.42286 4.08333 4C4.08333 5.57714 5.39 6.85714 7 6.85714C8.61 6.85714 9.91667 5.57714 9.91667 4C9.91667 2.42286 8.61 1.14286 7 1.14286ZM9.91667 9.14286C12.172 9.14286 14 10.9336 14 13.1429V14.2857C14 14.7407 13.8155 15.1757 13.4881 15.4986C13.1585 15.8193 12.7145 16 12.25 16H1.75C1.28552 16 0.841456 15.8193 0.511877 15.4986C0.184483 15.1757 0 14.7407 0 14.2857V13.1429C0 10.9336 1.82803 9.14286 4.08333 9.14286H9.91667ZM9.91667 10.2857H4.08333C2.47188 10.2857 1.16667 11.5643 1.16667 13.1429V14.2857C1.16667 14.4379 1.22865 14.5829 1.33729 14.69C1.44667 14.7964 1.59469 14.8571 1.74999 14.8571H12.25C12.4053 14.8571 12.5533 14.7964 12.6627 14.69C12.7713 14.5828 12.8333 14.4379 12.8333 14.2857V13.1429C12.8333 11.5643 11.5281 10.2857 9.91667 10.2857Z",
    fill: "#FF5956"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcUser);
export default __webpack_public_path__ + "static/media/ic_user.ade0a1a37d31523893aec9acf5845223.svg";
export { ForwardRef as ReactComponent };